import React from "react";
import "./JobPost.css";

const TechCableur = () => {
  return (
    <section className="job-post">
      <a href="/join" className="back-link">← Retour aux offres</a>
      <h1 className="job-title">Technicien&nbsp;/ Câbleur&nbsp;en&nbsp;Électronique&nbsp;(H/F)</h1>

      <div className="job-info">
        <span>📍 Neuilly Plaisance</span>
        <span>📄 CDI</span>
        <span>⏳ Temps partiel</span>
        <span>👤 Débutant à 2 ans</span>
      </div>

      <div className="job-content">
        <div className="job-description">
          <h2>Présentation du poste</h2>
          <p>
            Le technicien / câbleur en électronique est responsable de l’assemblage,
            du câblage et de la mise en service de composants électroniques sur
            des cartes, châssis ou armoires électriques. <br/>Il intervient dans divers
            secteurs : aéronautique, automobile, médical ou télécommunications.
          </p>

          <h3>Missions principales</h3>
          <ul>
            <li>Lire et interpréter des schémas électroniques ou électriques</li>
            <li>Assembler et câbler des composants sur des cartes ou châssis</li>
            <li>Réaliser des soudures manuelles ou semi-automatisées</li>
            <li>Effectuer tests de fonctionnement / conformité avec multimètre, oscilloscope…</li>
            <li>Diagnostiquer et réparer les défauts identifiés</li>
            <li>Rédiger rapports d’intervention et documents techniques</li>
          </ul>

          <h3>Compétences requises</h3>
          <h4>Techniques</h4>
          <ul>
            <li>Maîtrise des techniques de soudure et brasage</li>
            <li>Connaissance des normes de sécurité électrique & procédures qualité</li>
            <li>Utilisation d’appareils de mesure électronique</li>
            <li>Travail précis sur composants de petite taille</li>
          </ul>
          <h4>Comportementales</h4>
          <ul>
            <li>Rigueur et minutie</li>
            <li>Esprit d’équipe</li>
            <li>Autonomie et sens de l’organisation</li>
            <li>Adaptabilité aux évolutions technologiques</li>
          </ul>

          <h3>Formation et expérience</h3>
          <ul>
            <li>CAP/BEP à Bac pro/techno en électronique ou électricité</li>
            <li>Première expérience appréciée</li>
            <li>Habilitations électriques selon missions</li>
          </ul>

          <h3>Conditions de travail</h3>
          <ul>
            <li>Atelier, laboratoire ou site client</li>
            <li>Port d’EPI selon tâches</li>
            <li>Horaires réguliers, heures sup. possibles</li>
          </ul>

          <h3>Évolution professionnelle</h3>
          <p>
            Avec l’expérience, possibilité d’évolution vers technicien tests, chef
            d’équipe ou postes en bureau d’études / maintenance.
          </p>

          <h3>Candidature</h3>
          <p>
            Merci d’envoyer votre CV et lettre de motivation à&nbsp;:{" "}
            <a href="mailto:jcp-contact@orange.fr">jcp-contact@orange.fr</a>
          </p>
        </div>
      </div>

      <footer className="footer" style={{ background: "white" }}>
        <p>
          Powered by <strong>JCP Industries</strong>
        </p>
      </footer>
    </section>
  );
};

export default TechCableur;
